// extracted by mini-css-extract-plugin
module.exports = {"facetLink":"FacetItem_facetLink__JqkxY","active":"FacetItem_active__Hh2_B","disabled":"FacetItem_disabled__WZnzm"};